export default __webpack_public_path__ + "static/media/Instagram.702cc58f.svg";